export default __webpack_public_path__ + "static/media/chess-black-brown-pieces(reduced).df664151.webp";